import {CachedPDFContextProvider} from 'components/CachedPDF/context';
import CachedPDFControls from 'components/CachedPDF/Controls';
import CachedPDFFlatlist from 'components/CachedPDF/Flatlist';
import CachedPDFImage from 'components/CachedPDF/Image';
import PagePreviews from 'components/CachedPDF/PagePreviews';
import {FC} from 'react';

type PDFReaderProps = {
    maxPages: number;
    showControls: boolean;
    src: string;
};
const PDFReader: FC<PDFReaderProps> = ({maxPages, showControls, src}) => (
    <div className="flex w-full flex-1 flex-col items-center bg-grey-200 p-2">
        <div className="flex w-full max-w-3xl flex-1 flex-col">
            <CachedPDFContextProvider>
                {showControls && (
                    <CachedPDFControls
                        className="mb-2 rounded border border-grey-400"
                        include={['page', 'page-previews']}
                    />
                )}
                <CachedPDFFlatlist
                    className="rounded border border-grey-400"
                    pages={maxPages}
                    renderPage={({page}) => (
                        <CachedPDFImage page={page} src={src} />
                    )}
                    renderPagePreview={() => <PagePreviews src={src} />}
                />
            </CachedPDFContextProvider>
        </div>
    </div>
);
export default PDFReader;
